<script lang="ts">
  import "normalize.css";
  import "milligram/dist/milligram.css";

  import Player from "./Components/Player.svelte";
  import Footer from "./Components/Footer.svelte";

  let isWeixin: boolean =
    navigator?.userAgent?.toLowerCase().indexOf("micromessenger") !== -1;
</script>

<div class="container" id="root">
  <div class="row">
    <div class="column column-80 column-offset-10">
      <h1>💸&nbsp;&nbsp;💰</h1>
      <h3>💴💵💶💳💷</h3>
      <h4>输入金额，即刻到账！</h4>
    </div>
  </div>

  <div class="row"><Player /></div>

  {#if isWeixin}
    <p class="tip-text">如需下载mp3请用浏览器打开</p>
  {/if}
</div>

<footer>
  <a target="_blank" href="https://mp.weixin.qq.com/s/kvNHp2Cwual7-BhmbVua2Q">
    ©有趣研究社
  </a>
</footer>

<!-- 悬浮图标 -->
<a
  class="fq-custom"
  target="_blank"
  href="https://mp.weixin.qq.com/s/kvNHp2Cwual7-BhmbVua2Q"
  style="
      z-index:100;
      position: fixed;
      right: 1px;
      bottom: 200px;
      color: #fff;
      background: linear-gradient(90deg, rgb(0 0 0 / 30%), rgb(0 0 0 / 30%));
      border-top-left-radius: 25px;
      border-bottom-left-radius: 25px;
      padding: 0 3px;
    "
>
  <img
    style="
            line-height: 70px;
            width: 80px;
            -webkit-filter: drop-shadow(0 3px 8px rgba(84, 30, 15, .8));
            filter: drop-shadow(0 3px 8px rgba(84, 30, 15, .8));
          "
    alt="更多好玩"
    src="/more.png"
  />
</a>

<!-- <Footer /> -->
<style>
  :global(body) {
    font-family: -apple-system, "Noto Sans", "Helvetica Neue", Helvetica,
      "Nimbus Sans L", Arial, "Liberation Sans", "PingFang SC",
      "Hiragino Sans GB", "Noto Sans CJK SC", "Source Han Sans SC",
      "Source Han Sans CN", "Microsoft YaHei", "Wenquanyi Micro Hei",
      "WenQuanYi Zen Hei", "ST Heiti", SimHei, "WenQuanYi Zen Hei Sharp",
      sans-serif;
  }

  h1,
  h3,
  h4 {
    text-align: center;
  }

  h4 {
    margin-bottom: 9vh;
  }

  #root {
    margin-top: 15vh;
  }

  .tip-text {
    text-align: center;
    font-size: 12px;
  }
  footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    line-height: 50px;
    text-align: center;
  }
</style>
